import { render, staticRenderFns } from "./EditTags.vue?vue&type=template&id=27a56509&scoped=true&"
import script from "./EditTags.vue?vue&type=script&lang=js&"
export * from "./EditTags.vue?vue&type=script&lang=js&"
import style0 from "./EditTags.vue?vue&type=style&index=0&id=27a56509&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a56509",
  null
  
)

export default component.exports